import { Injectable, OnDestroy } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute} from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { take, skip } from 'rxjs/operators';
import { AuthService } from '../../_services/index';

@Injectable()
export class DemoRouteGuard implements OnDestroy {
  private licenceSubscription: Subscription | null = null;
  private currentRouteSnapshot: ActivatedRouteSnapshot | null = null;
  private currentStateSnapshot: RouterStateSnapshot | null = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {
    this.setupLicenceWatcher();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Store current route snapshots for potential re-triggering
    this.currentRouteSnapshot = next;
    this.currentStateSnapshot = state;
    
    return this.evaluateGuard();
  }

  private evaluateGuard(): boolean {
    const isAuthorizedUser = this.authService.isArchitect() || 
                            this.authService.isAdmin() || 
                            this.authService.isCollaborateur();
    const licence = this.authService.licenceObserver$.value;

    if (!isAuthorizedUser) {
      return this.handleUnauthorizedAccess(this.currentStateSnapshot?.url || '');
    }
    console.log('licence 1', licence);
    if(licence !== 'pre-free-trial') {
      this.router.navigate(['/architect/my-consultations']);
      return false;
    }
    return true;
  }

  private setupLicenceWatcher(): void {
    // Skip the initial value and take only the second emission (first actual change)
    this.licenceSubscription = this.authService.licenceObserver$
      .pipe(
        skip(1), // Skip initial value
        take(1)  // Take only the first change (second emission)
      )
      .subscribe(() => {
        this.evaluateGuard()
      });
  }

  private handleUnauthorizedAccess(returnUrl: string): boolean {
    this.router.navigate(['/login'], { 
      queryParams: { 
        returnUrl: returnUrl, 
        infoBubble: "login-required" 
      }
    });
    return false;
  }

  ngOnDestroy(): void {
    if (this.licenceSubscription) {
      this.licenceSubscription.unsubscribe();
    }
  }
}
